const arrKeys: readonly [string, string][] = [
  ['OTHER', 'n/a'],
  ['ALL APP', 'W'],
];

export const mapKeys = new Map(arrKeys);
export const mapKeysTurn = new Map(arrKeys.map(([a, b]) => [b, a]));
